<template>
    <div class="text-center">
        <div v-if="installment !== undefined">
            {{ installment.due_at | moment('DD/MM/YYYY') }} <br />
            {{ installment.pay_at === null ? 'Não pago' : (installment.reversal_at === null ? 'Pago' : 'Estornado') }} <br />
            R${{ installment.price | price }}
        </div>
        <div v-else>
            -
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            installment: Object
        }
    };
</script>